import { CommonResponseModel } from "@project-management-system/shared-models";
import { ItemAttributeService } from "./item-attribute.service";
import { ApplicationExceptionHandler } from 'libs/backend-utils';
import { Body, Controller, Post } from "@nestjs/common";
import { ItemAttributeDto } from "./dto/item-attribute-dto";
import { ApiBody, ApiTags } from "@nestjs/swagger";

@ApiTags('item-attribute')
@Controller('item-attribute-controller')
export class ItemAttributeController {
    constructor(private itemservice: ItemAttributeService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

@Post('/createItemAttribute')
@ApiBody({type:ItemAttributeDto})
async createItemAttribute(@Body()createDto:any):Promise<CommonResponseModel>{
try{
return await this.itemservice.createItemAttribute(createDto)
}catch (err){
return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
}
}

@Post('/getItemAttribute')
@Post('/getAll')
async getItemAttribute(): Promise<CommonResponseModel> {
    try {
        return this.itemservice.getItemAttribute()
    } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err)
    }
}
@Post('/getStyles')
async getStyles(): Promise<CommonResponseModel> {
    try {
        return this.itemservice.getStyles()
    } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err)
    }
}

@Post('/getAllItems')
async getAllItems(): Promise<CommonResponseModel> {
    try {
        return this.itemservice.getAllItems()
    } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err)
    }
}

@Post('/getImCode')
async getImCode(): Promise<CommonResponseModel> {
    try {
        return this.itemservice.getImCode()
    } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err)
    }
}


    }

    